import './src/vaadin-message-input.js';
export * from './src/vaadin-message-input.js';
